import type { Immutable } from "immer";
import React from "react";
import { ProductReviewsSSR } from "tsi-common-react/src/apps/reviews/ProductReviewsSSR/index";
import { ReviewsComponentTypes } from "tsi-common-react/src/apps/reviews/constants";
import { getGlobalSpacingClasses } from "tsi-common-react/src/components/_spacing/globalSpacing";

import type { FullReviewsBlock as FullReviewsBlockValue } from "@reactivated";
import { templates } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles from "./index.module.scss";

export const CocoonFullReviewsBlock = (
    props: Immutable<{
        value: FullReviewsBlockValue;
        reviews?: templates.ProductReviewsTemplate | null;
    }>,
): React.JSX.Element => (
    <section
        className={concatClassNames([
            styles.fullReviewsBlock,
            "full-reviews-block",
            getGlobalSpacingClasses(props.value.spacing),
        ])}
    >
        {props.reviews ? (
            <div id="reviews">
                <ProductReviewsSSR
                    {...props.reviews}
                    starHasStroke={true}
                    reviewsComponentType={ReviewsComponentTypes.CAROUSEL}
                    showWriteReviewButton={false}
                    isCollapsedView={true}
                />
            </div>
        ) : null}
    </section>
);
